import { makeIcon } from "components/ui/Icon";

export const UserRiskIcon = makeIcon(
  <svg fill="none" viewBox="0 -960 960 960">
    <path
      d="M80-720v-120q0-33 23.5-56.5T160-920h120v80H160v120H80Zm200 600H160q-33 0-56.5-23.5T80-200v-120h80v120h120v80Zm520-600v-120H680v-80h120q33 0 56.5 23.5T880-840v120h-80Zm-316.5 76.5Q460-667 460-700t23.5-56.5Q507-780 540-780t56.5 23.5Q620-733 620-700t-23.5 56.5Q573-620 540-620t-56.5-23.5ZM352-280l40-204-72 28v136h-80v-188l158-68q35-15 51.5-19.5T480-600q21 0 39 11t29 29l40 64q11 17 24 31.5t30 26.5l-41 71q-17-11-32.5-24.5T540-420l-28 140H352ZM600-80q-23 0-34.5-20t-.5-40l160-280q13-19 36-21t34 21l160 280q13 20 0 40t-35 20H600Zm174-46q6-6 6-14t-6-14q-6-6-14-6t-14 6q-6 6-6 14t6 14q6 6 14 6t14-6Zm-34-74h40v-160h-40v160Z"
      fill="currentColor"
    />
  </svg>,
);
